export default {
  activeTab: 'activeTab',
  project: {
    loading: 'project.loading',
    notFound: 'project.notFound',
    id: 'project.id',
    isStory: 'project.isStory',
    role: 'project.role',
    header: {
      edit: 'project.header.edit'
    },
    defaultFirstToLast: 'project.defaultFirstToLast',
    permissions: {
      edit: 'project.permissions.edit',
      chat: 'project.permissions.chat',
      liveChat: 'project.permissions.liveChat'
    },
    chatType: 'project.chatType',
    isOnline: 'project.isOnline',
    displayType: 'project.displayType',
    judgeGroups: 'project.judgeGroups',
    qrLink: 'project.qrLink'
  },
  posts: {
    id: 'posts.id',
    loading: 'posts.loading',
    page: 'posts.page',
    hasMore: 'posts.hasMore',
    total: 'posts.total',
    fetch: 'posts.fetch',
    fetchTo: 'posts.fetchTo',
    sort: 'posts.sort',
    sortNewest: 'posts.sortNewest',
    edit: 'posts.edit',
    repliesExpanded: 'posts.repliesExpanded',
    toggleReplies: 'posts.toggleReplies',
    permissions: {
      create: 'posts.permissions.create',
      edit: 'posts.permissions.edit'
    },
    hasModifiedPosts: 'posts.hasModifiedPosts',
    customPostOrder: 'posts.customPostOrder'
  },
  paywall: 'paywall',
  grid: {
    modalVisible: 'grid.modalVisible'
  },
  hasUnsavedAttachmentsKey: 'hasUnsavedAttachments',
  comments: {
    scrollTo: (postID) => `comments.scrollTo.${postID}`,
    permissions: {
      create: 'comments.permissions.create'
    }
  }
}
